import { Analytics } from 'firebase/analytics';
import { Messaging } from 'firebase/messaging';
import { create } from 'zustand';

interface FirebaseConfigSessionStoreState {
  analytics: Analytics | null;
  messaging: Messaging | null;
  serviceWorker: ServiceWorkerRegistration | null;
  setAnalytics: (analytics: Analytics | null) => void;
  setMessaging: (messaging: Messaging | null) => void;
  setServiceWorker: (serviceWorker: ServiceWorkerRegistration | null) => void;
}

export const useFirebaseConfigSessionStore = create<FirebaseConfigSessionStoreState>(set => ({
  analytics: null,
  messaging: null,
  serviceWorker: null,
  setAnalytics: analytics => set({ analytics }),
  setMessaging: messaging => set({ messaging }),
  setServiceWorker: serviceWorker => set({ serviceWorker }),
}));
